import { AllowLoginArgs, BindCompanyUserArgs, BindSchoolCanteenUserArgs, BindSchoolCompanyUserArgs, BindSchoolUserArgs, ChangePswArgs, CreateGegistMealArgs, EditCompanyArgs, EditConfigArgs, EditGradeArgs, EditGradeClassArgs, EditMenuArgs, EditNewsArgs, EditNewsTypeArgs, EditOffSchoolArgs, EditRoleArgs, EditSchoolArgs, EditSchoolCalendarArgs, EditSelfArgs, EditStudentArgs, EditTeacherArgs, EditUserArgs, EditVacateArgs, LoginArgs, QueryActionLogArgs, QueryCompanyArgs, QueryGetSchoolCalendarMonthlyArgs, QueryGetSchoolCalendarYearlyArgs, QueryGradeArgs, QueryGradeClassArgs, QueryMenuArgs, QueryNewsArgs, QueryNewsTypeArgs, QueryOffSchoolArgs, QueryRegisterMealArgs, QueryResourceArgs, QueryRoleArgs, QuerySchoolArgs, QueryStudentArgs, QueryTeacherArgs, QueryUserArgs, QueryVacateArgs, SetMenuArgs, StudentDineStatArgs, UploadResourceArgs, VacateStatArgs } from "@/models/args";
import { BaseClass } from "./base";
import { ActionLogDto, CompanyDto, ConfigDto, GradeClassDto, GradeDto, ImportStudentDto, ImportStudentResultDto, LoginDto, MenuDto, NewsDto, NewsTypeDto, OffSchoolDto, RegisterMealDto, ResourceDto, RoleDto, SchoolCalendarDto, SchoolCalendarMonthDto, SchoolDto, StatCountDto, StatLineDto, StudentDto, TeacherDto, UserDto, VacateDto, VacateStatDto } from "@/models/dtos";
import { ResponseDataType } from "@/models/types";

export class AccountClass extends BaseClass{
  login(args: LoginArgs){
    return this.post<LoginDto>('/api/Account/ManageLogin', args)
  }

  info(){
    return this.get<UserDto>('/api/Account/UserCache')
  }

  changePsw(args: ChangePswArgs){
    return this.post<number>('/api/Account/ChangePsw', args)
  }

  logout(){
    return this.get<number>('/api/Account/Logout')
  }
}

export class ActionLogClass extends BaseClass{
  gets(args: QueryActionLogArgs){
    return this.get<ResponseDataType<ActionLogDto>>('/api/ActionLog', args)
  }
}

export class CompanyClass extends BaseClass{
  gets(args: QueryCompanyArgs){
    return this.get<ResponseDataType<CompanyDto>>('/api/Company', args)
  }

  create(args: EditCompanyArgs){
    return this.post<number>('/api/Company', args)
  }

  edit(args: EditCompanyArgs){
    return this.put<number>('/api/Company', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/Company/${id}`)
  }

  detail(id: number){
    return this.get<CompanyDto>(`/api/Company/${id}`)
  }

  bind(args: BindCompanyUserArgs){
    return this.post<number>('/api/Company/BindCompanyUser', args)
  }

  unbind(id: number){
    return this.get<number>('/api/Company/UnbindCompanyUser', {id})
  }
}

export class ConfigClass extends BaseClass{
  gets(){
    return this.get<ConfigDto[]>('/api/Config')
  }

  create(args: EditConfigArgs){
    return this.post<number>('/api/Config', args)
  }

  edit(args: EditConfigArgs[]){
    return this.put<number>('/api/Config', args)
  }
}

export class GradeClassClass extends BaseClass{
  gets(args: QueryGradeClassArgs){
    return this.get<ResponseDataType<GradeClassDto>>('/api/GradeClass', args)
  }

  create(args: EditGradeClassArgs){
    return this.post<number>('/api/GradeClass', args)
  }

  edit(args: EditGradeClassArgs){
    return this.put<number>('/api/GradeClass', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/GradeClass/${id}`)
  }

  detail(id: number){
    return this.get<GradeClassDto>(`/api/GradeClass/${id}`)
  }

  unbind(id: number){
    return this.get<number>('/api/GradeClass/UnbindTeacher', {id})
  }

  bind(classId: number, teacherId: number){
    return this.get<number>('/api/GradeClass/BindTeacher', {classId, teacherId})
  }
}

export class GradeClass extends BaseClass{
  gets(args: QueryGradeArgs){
    return this.get<ResponseDataType<GradeDto>>('/api/Grade', args)
  }

  create(args: EditGradeArgs){
    return this.post<number>('/api/Grade', args)
  }

  edit(args: EditGradeArgs){
    return this.put<number>('/api/Grade', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/Grade/${id}`)
  }

  detail(id: number){
    return this.get<GradeDto>(`/api/Grade/${id}`)
  }
}

export class MenuClass extends BaseClass{
  gets(args: QueryMenuArgs){
    return this.get<ResponseDataType<MenuDto>>('/api/Menu', args)
  }

  create(args: EditMenuArgs){
    return this.post<number>('/api/Menu', args)
  }

  edit(args: EditMenuArgs){
    return this.put<number>('/api/Menu', args)
  }

  sort(id: number, sort: number){
    return this.get<number>(`/api/Menu/${id}/${sort}`)
  }

  menus(){
    return this.get<MenuDto[]>('/api/Menu/GetUserRoleMenus')
  }
}

export class NewsClass extends BaseClass{
  gets(args: QueryNewsArgs){
    return this.get<ResponseDataType<NewsDto>>('/api/News', args)
  }

  create(args: EditNewsArgs){
    return this.post<number>('/api/News', args)
  }

  edit(args: EditNewsArgs){
    return this.put<number>('/api/News', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/News/${id}`)
  }

  detail(id: number){
    return this.get<NewsDto>(`/api/News/Get/${id}`)
  }

  publish(id: number, status: number){
    return this.put<number>(`/api/News/ChangePublishStatus/${id}/${status}`)
  }

  top(id: number, status: number){
    return this.put<number>(`/api/News/ChangeIsTop/${id}/${status}`)
  }

  home(id: number, status: boolean){
    return this.put<number>(`/api/News/ChangeIsHomeShow/${id}/${status}`)
  }
}

export class NewsTypeClass extends BaseClass{
  gets(args: QueryNewsTypeArgs){
    return this.get<ResponseDataType<NewsTypeDto>>('/api/NewsType', args)
  }

  create(args: EditNewsTypeArgs){
    return this.post<number>('/api/NewsType', args)
  }

  edit(args: EditNewsTypeArgs){
    return this.put<number>('/api/NewsType', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/NewsType/${id}`)
  }

  detail(id: number){
    return this.get<NewsTypeDto>(`/api/NewsType/${id}`)
  }

  sort(id: number, sort: number){
    return this.put<number>(`/api/NewsType/Sort/${id}/${sort}`)
  }
}


export class OffSchoolClass extends BaseClass{
  gets(args: QueryOffSchoolArgs){
    return this.get<ResponseDataType<OffSchoolDto>>('/api/OffSchool', args)
  }

  create(args: EditOffSchoolArgs){
    return this.post<number>('/api/OffSchool', args)
  }

  remove(id: number){
    return this.delete<number>('/api/OffSchool', {id})
  }

  exports(args: QueryOffSchoolArgs){
    return this.export<File>('/api/OffSchool', 'GET', args)
  }
}

export class RegisterMealClass extends BaseClass{
  gets(args: QueryRegisterMealArgs){
    return this.get<ResponseDataType<RegisterMealDto>>('/api/RegisterMeal', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/RegisterMeal/${id}`)
  }

  create(arg: CreateGegistMealArgs){
    return this.post<number>('/api/RegisterMeal/MiniReg', arg)
  }

  autoReg(gradeId: number, mealMonth: string){
    return this.get<number>('/api/RegisterMeal/AutoReg', {gradeId, mealMonth})
  }

  exports(args: QueryRegisterMealArgs){
    return this.export<File>('/api/RegisterMeal/ExportRegs', 'GET', args)
  }
}

export class ResourceClass extends BaseClass{
  gets(args: QueryResourceArgs){
    return this.get<ResponseDataType<ResourceDto>>('/api/Resource', args)
  }

  create(args: FormData){
    return this.post<ResourceDto>('/api/Resource', args)
  }
}

export class RoleClass extends BaseClass{
  gets(args: QueryRoleArgs){
    return this.get<ResponseDataType<RoleDto>>('/api/Role', args)
  }

  all(){
    return this.get<RoleDto[]>('/api/Role/GetAllRoles')
  }

  create(args: EditRoleArgs){
    return this.post<number>('/api/Role', args)
  }

  edit(args: EditRoleArgs){
    return this.put<number>('/api/Role', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/Role/${id}`)
  }

  setMenus(id: number, args: SetMenuArgs){
    return this.put<number>(`/api/Role/${id}`, args)
  }
}

export class SchoolCalendarClass extends BaseClass{
  getMonth(args: QueryGetSchoolCalendarMonthlyArgs){
    return this.get<SchoolCalendarDto[]>('/api/SchoolCalendar/GetMonthly', args)
  }

  getYear(args: QueryGetSchoolCalendarYearlyArgs){
    return this.get<SchoolCalendarMonthDto[]>('/api/SchoolCalendar/YearSetState', args)
  }

  create(args: EditSchoolCalendarArgs[]){
    return this.post<number>('/api/SchoolCalendar', args)
  }

  getStudentMounthState(studentId: number){
    return this.get<number>(`/api/SchoolCalendar/GetStudentMounthState/${studentId}`)
  }
}

export class SchoolClass extends BaseClass{
  gets(args: QuerySchoolArgs){
    return this.get<ResponseDataType<SchoolDto>>('/api/School', args)
  }

  create(args: EditSchoolArgs){
    return this.post<number>('/api/School', args)
  }

  edit(args: EditSchoolArgs){
    return this.put<number>('/api/School', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/School/${id}`)
  }

  bindUser(args: BindSchoolUserArgs){
    return this.get<number>('/api/School/BindSchoolUser', args)
  }

  bindCanteen(args: BindSchoolCanteenUserArgs){
    return this.get<number>('/api/School/BindCanteenUser', args)
  }

  bindCompany(args: BindSchoolCompanyUserArgs){
    return this.get<number>('/api/School/BindCompany', args)
  }
}

export class StudentClass extends BaseClass{
  gets(args: QueryStudentArgs){
    return this.get<ResponseDataType<StudentDto>>('/api/Student', args)
  }

  create(args: EditStudentArgs){
    return this.post<number>('/api/Student', args)
  }

  edit(args: EditStudentArgs){
    return this.put<number>('/api/Student', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/Student/${id}`)
  }

  exports(args: QueryStudentArgs){
    return this.export<File>('/api/Student/ExportStudents', 'GET', args)
  }

  download(){
    return this.export<File>('/api/Student/ExprtStudentTpl', 'GET', null)
  }
}

export class TeacherClass extends BaseClass{
  gets(args: QueryTeacherArgs){
    return this.get<ResponseDataType<TeacherDto>>('/api/Teacher', args)
  }

  create(args: EditTeacherArgs){
    return this.post<number>('/api/Teacher', args)
  }

  edit(args: EditTeacherArgs){
    return this.put<number>('/api/Teacher', args)
  }

  remove(id: number){
    return this.delete<number>(`/api/Teacher/${id}`)
  }

  unbind(id: number){
    return this.delete<number>(`/api/Teacher/UnbindTeacher/${id}`)
  }

  exports(args: QueryTeacherArgs){
    return this.export<File>('/api/Teacher/ExportTeachers', 'GET', args)
  }
}

export class UserClass extends BaseClass{
  gets(args: QueryUserArgs){
    return this.get<ResponseDataType<UserDto>>('/api/User', args)
  }

  create(args: EditUserArgs){
    return this.post<number>('/api/User', args)
  }

  edit(args: EditUserArgs){
    return this.put<number>('/api/User', args)
  }

  self(args: EditSelfArgs){
    return this.put<number>('/api/User/ModifySelf', args)
  }

  remove(id: string){
    return this.delete<number>(`/api/User/${id}`)
  }

  allow(args: AllowLoginArgs){
    return this.get<number>('/api/User/AllowLogin', args)
  }
}

export class VacateClass extends BaseClass{
  gets(args: QueryVacateArgs){
    return this.get<ResponseDataType<VacateDto>>('/api/Vacate', args)
  }

  exports(args: QueryVacateArgs){
    return this.export<File>('/api/Vacate/ExportRegs', 'GET', args)
  }

  create(args: EditVacateArgs){
    return this.post<number>('/api/Vacate', args)
  }

  destroy(id: number){
    return this.get<number>(`/api/Vacate/Destroy/${id}`)
  }

  stat(){
    return this.get<StatCountDto>('/api/Vacate/VacateSumStat')
  }

  line(){
    return this.get<StatLineDto[]>('/api/Vacate/MonthVacateStat')
  }

  vacateStat(args: VacateStatArgs){
    return this.get<VacateStatDto[]>('/api/Vacate/VacateStat', args)
  }

  exportVacateStat(args: VacateStatArgs){
    return this.export<File>('/api/Vacate/ExportVacateStat','GET', args)
  }

  studentDineDetailStat(args: StudentDineStatArgs){
    return this.get<string>('/api/Vacate/StudentDineDetailStat', args)
  }

  exportStudentDineDetailStat(args: StudentDineStatArgs){
    return this.export<File>('/api/Vacate/ExportStudentDineDetailStat','GET', args)
  }

  gradeClassDineStat(args: StudentDineStatArgs){
    return this.get<string>('/api/Vacate/GradeClassDineStat', args)
  }

  exportGradeClassDineStat(args: StudentDineStatArgs){
    return this.export<File>('/api/Vacate/ExportGradeClassDineStat','GET', args)
  }
}

export class StudentDataClass extends BaseClass{
  importFile(formdata: FormData){
    return this.upload<ImportStudentResultDto>('/api/StudentData/Import', formdata)
  }

  confirmImport(args: ImportStudentDto[]){
    return this.post<number>('/api/StudentData/ConfirmImport', args)
  }

  getInfo(schoolId: number){
    return this.get<string>('/api/StudentData/GetImportMessage', {schoolId})
  }

  clearInfo(schoolId: number){
    return this.get<number>('/api/StudentData/RemoteQueue', {schoolId})
  }
}